import React, { useEffect } from 'react'
import WCLLogo from "../assets/images/new_logo1.png"
import { NavLink } from "react-router-dom";

const Footer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <footer className="footer-section">
        <div className="footer-container">
          <div className="footer-cta">
          </div>
          <div className="footer-content">
            <div className="grid-2">

              <div className="footer-widget">
                <div className="footer-logo">
                  <img src={WCLLogo} className="img-fluid" alt="logo" />
                </div>
                <div className="footer-text">
                  <p>Water and Climate Lab,<br />
                    AB-4/326,<br />
                    Indian Institute of Technology Gandhinagar.<br />
                    Palaj, Gandhinagar, Gujarat, PIN - 382355.</p>
                  <div style={{ display: "none" }}>
                    <a href='https://clustrmaps.com/site/1altr' title='Visit tracker'><img
                      src='//clustrmaps.com/map_v2.png?cl=fefefe&w=a&t=tt&d=KQmDGlOaW_hm7zhdeP4pOltsnWVrCY6umYLeRp1Re_M&co=151414&ct=fefefe' alt="Visitor map" /></a>

                  </div>


                </div>
              </div>

              <div className="footer-widget">
                <div className="footer-widget-heading">
                  <h3>Quick links</h3>
                </div>
                <ul>
                  <li><NavLink to="/" onClick={() => window.scrollTo(0, 0)}>Home</NavLink></li>
                  <li><a href="https://iitgn.ac.in/" target={'_blank'} rel="noreferrer">IITGN</a></li>
                  <li><NavLink to="/research" onClick={() => window.scrollTo(0, 0)}>Research Areas</NavLink></li>
                  {/* <li><NavLink to="/grants-and-funds" onClick={() => window.scrollTo(0, 0)}>Grants & Funds</NavLink></li> */}
                  <li><NavLink to="/publications" onClick={() => window.scrollTo(0, 0)}>Publications</NavLink></li>
                  <li><NavLink to="/data" onClick={() => window.scrollTo(0, 0)}>Data</NavLink></li>
                  <li><NavLink to="/people" onClick={() => window.scrollTo(0, 0)}>People</NavLink></li>
                  <li><NavLink to="/news" onClick={() => window.scrollTo(0, 0)}>News</NavLink></li>
                  <li><a href="https://indiadroughtmonitor.in/" target={'_blank'} rel="noreferrer">India Drought Monitor</a></li>
                  <li><a href="https://geoportalofindiandams.github.io/GeoID/" target={'_blank'} rel="noreferrer">Geoportal of Indian Dams (GeoID)</a></li>
                  <li><a href="https://sites.google.com/iitgn.ac.in/expforecastlandsurfaceproducts/home?authuser=0" target={'_blank'} rel="noreferrer">EFLSP (IMD)</a></li>
                  <li><NavLink to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact Us</NavLink></li>
                  {/* <li><NavLink to="/website-visitor" onClick={() => window.scrollTo(0, 0)}>Website Visitors</NavLink></li> */}
                </ul>
              </div>

            </div>
          </div>
        </div>
        <div className="copyright_container">
          <div className="copyright_area">
            <div className="grid-2">
              <div className="copyright-text">
                <p>&copy; 2023 Water & Climate Lab. All rights reserved</p>
              </div>
              <div className="footer-menu">
                <ul>
                  {/* <li><NavLink to="/website-visitor" onClick={() => window.scrollTo(0, 0)}>Website Visitors</NavLink></li>
                 */}
                  <li><a href='https://clustrmaps.com/site/1altr' target="_blank" rel="noreferrer">Website Visitors</a></li>

                  <li><NavLink to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</NavLink></li>
                  <li><NavLink to="/disclaimer" onClick={() => window.scrollTo(0, 0)}>Disclaimer</NavLink></li>

                </ul>
              </div>

            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer